/**
 * Hotel item-policy calculate requires lat/long (backend resolves place hierarchy from coords).
 * Destination budget searches often only have lePlaceId until the place record is loaded.
 */
export function getCoordinatesFromPlace(place?: App.Place): { latitude: string; longitude: string } | undefined {
  const centre = place?.boundingRadius?.centre
  if (centre?.latitude == null || centre?.longitude == null) {
    return undefined
  }
  return {
    latitude: centre.latitude.toString(),
    longitude: centre.longitude.toString(),
  }
}

export function resolveHotelItemPolicyLocation(params: {
  latitude?: string
  longitude?: string
  placeFromId?: App.Place
}): { latitude: string; longitude: string } | undefined {
  const latitude = params.latitude?.trim()
  const longitude = params.longitude?.trim()
  if (latitude && longitude) {
    return { latitude, longitude }
  }
  return getCoordinatesFromPlace(params.placeFromId)
}

export function hasHotelItemPolicyLocation(
  location: { lePlaceId: string } | { latitude: string; longitude: string },
): boolean {
  if ('lePlaceId' in location) {
    return !!location.lePlaceId.trim()
  }
  return !!(location.latitude.trim() && location.longitude.trim())
}
